// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"592":"738c4437","856":"5402373b","952":"cdc4479b"}[chunkId] + ".chunk.js";
};